import React, {useEffect, useState} from 'react';
import {Portlet, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import BlockUi from "@availity/block-ui";
import axios from "../../../helpers/axios";
import sayError from "../../../helpers/sayError";
import RateHawkDay from "./RateHawkDay";
import SearchSelect from "../../../components/searchSelect";
import {Form} from "react-bootstrap";
import _ from "lodash"

const RateHawk = () => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(true)
  const [usersList, setUsersList] = useState()
  const [full, setFull] = useState(true)
  const [filteredData, setFilteredData] = useState()
  const [activeUser, setActiveUser] = useState(null)
  const [freeCancels, setFreeCancels] = useState(false)
  useEffect(() => {
    axios.post("/api/dashboard/unpaidOrdersRatehawk")
      .then(({data})=>{
        console.log("RateHawk",data)
        const {canBeFreeCancelled, ...mainInfo} = data.orders
        setData(data.orders)
        setFilteredData(mainInfo)
        let users = []
        Object.keys(data.orders).forEach((key, i)=>{
          data.orders[key].forEach(item=>{
            users.push(item.issuedBy)
          })
        })
        setUsersList(_.uniq(users).map(v=>({label:v, value:v})))
      }).finally(()=> {
      setLoading(false)
    })
  }, []);

  useEffect(() => {
    if(data){
      filteredOrder()
    }
  }, [activeUser,freeCancels]);

  const filteredOrder = () =>{
    let dupleArrays = {}
    const {canBeFreeCancelled, ...mainInfo} = data
    console.log('f', data, filteredData, canBeFreeCancelled)
    if(freeCancels){
      dupleArrays = {canBeFreeCancelled}
    } else {
      if(activeUser){
        Object.keys(mainInfo).forEach((key, i)=>{
          dupleArrays[key] = _.filter(data[key], {issuedBy: activeUser})
        })
      }else{
        dupleArrays = mainInfo
      }
    }
    setFilteredData(dupleArrays)
  }

  return (
    <Portlet>
      <PortletHeader title={'Оплаты RateHawk'} toolbar={<PortletHeaderToolbar className={'gap-2'}>
        {data && usersList && !freeCancels && <>
          <div style={{width: '12rem'}}>
            <SearchSelect
              onChange={(v) => {
                setActiveUser(v)
              }}
              defaultValue={activeUser}
              label={'Выписал'}
              unregister
              array={[{value: null, label: 'Все'}, ...usersList]}/>
          </div>
          <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
            <input
              defaultChecked={full}
              checked={full}
              onChange={(e) => {
                setFull(!full)
              }}
              type={"checkbox"}
            />{" "}
            Полный
          </Form.Label>
        </>}
        <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
          <input
            defaultChecked={freeCancels}
            checked={freeCancels}
            onChange={(e) => {
              setFreeCancels(!freeCancels)
            }}
            type={"checkbox"}
          />{" "}
          Отмены
        </Form.Label>
      </PortletHeaderToolbar>}/>
      <BlockUi blocking={loading}>
        {data && Object.keys(filteredData).map((key, index) => {
          if (!full && !nameDay[key].shortcut) {
            return <React.Fragment key={index}/>
          }
          return <RateHawkDay key={index}
                              full={full}
                              info={filteredData[key]}
                              label={nameDay[key]}/>
        })}
      </BlockUi>
    </Portlet>
  );
};

export default RateHawk;

const nameDay = {
  overdue: {name: 'Просрочено', color: 'rgba(253,57,122,0.13 )', shortcut: true},
  today: {name:'Оплата на днях',color:'rgba(255,205,86,0.23)',  shortcut: true},
  tomorrow: {name:'Оплата позже', color:'rgba(128,255,86,0.23)', },
  canBeFreeCancelled: {name:'Бесплатная отмена', color:'rgba(128,255,86,0.23)', free: true }
}
